/* eslint-disable react/no-unescaped-entities */
import { useState } from 'react';
import { HOME } from '@/constants/testIds';

const FAQS = [
  {
    q: 'What if I only have an idea and no design?',
    a: "No problem at all. Many of our customers come to us with nothing more than an idea. We help turn rough concepts into custom designs ready for print.",
  },
  {
    q: 'What makes Shirt Happens Studio different?',
    a: "At Shirt Happens Studio, we don't just print shirts—we help bring ideas to life. We combine creativity, quality printing, and fast turnaround to create apparel that stands out.",
  },
  {
    q: 'Can you handle bulk or business orders?',
    a: "Yes! We handle single custom pieces as well as large bulk orders for businesses, ministries, schools, events, and teams.",
  },
  {
    q: 'Do you offer rush orders?',
    a: "Need it fast? Rush orders may be available depending on workload and design complexity. Contact us for availability.",
  },
  {
    q: 'Will I see a proof before printing?',
    a: "Yes. We provide a design mockup for approval before production begins to ensure you're happy before printing.",
  },
];

const FAQItem = ({ index, item, isOpen, onToggle }) => (
  <div
    data-testid={`${HOME.faqItem}-${index}`}
    className="border-2 border-black/15 rounded-2xl bg-white overflow-hidden transition-colors hover:border-black"
  >
    <button
      type="button"
      onClick={() => onToggle(index)}
      aria-expanded={isOpen}
      className="w-full text-left flex items-start gap-4 px-5 sm:px-7 py-5 sm:py-6"
    >
      <span
        className={[
          'mt-1 shrink-0 inline-flex items-center justify-center w-7 h-7 rounded-full font-display font-black text-lg leading-none transition-transform',
          isOpen ? 'bg-brand-orange text-black rotate-45' : 'bg-black text-white',
        ].join(' ')}
        aria-hidden="true"
      >
        +
      </span>
      <span className="flex-1">
        <span className="block font-display font-black text-lg sm:text-xl text-black leading-snug">
          {item.q}
        </span>
        {isOpen && (
          <span className="block font-body text-[15px] sm:text-base text-black/75 leading-relaxed mt-3">
            {item.a}
          </span>
        )}
      </span>
    </button>
  </div>
);

const FAQSection = () => {
  const [openIdx, setOpenIdx] = useState(0); // first one open by default
  const toggle = (i) => setOpenIdx((cur) => (cur === i ? -1 : i));

  return (
    <section
      id="faq"
      data-testid={HOME.faqSection}
      className="relative bg-[#FFF7EE] text-black py-24 sm:py-28 px-6 sm:px-12"
    >
      <div className="max-w-4xl mx-auto">
        <div className="mb-10 sm:mb-12">
          <p className="font-body text-xs sm:text-sm tracking-[0.4em] uppercase text-brand-orange mb-3">
            Frequently asked →
          </p>
          <h2 className="font-display font-black text-4xl sm:text-5xl md:text-6xl leading-[1.02] tracking-[-0.02em]">
            Questions <span className="text-brand-orange">we get a lot.</span>
          </h2>
          <p className="font-body text-base text-black/65 mt-5 max-w-2xl">
            Still wondering about something? Reach out and we'll get back to you
            with a real answer — no chatbot, no script.
          </p>
        </div>

        <div className="space-y-3 sm:space-y-4">
          {FAQS.map((item, i) => (
            <FAQItem
              key={item.q}
              index={i}
              item={item}
              isOpen={openIdx === i}
              onToggle={toggle}
            />
          ))}
        </div>

        <div className="mt-10 flex flex-wrap items-center gap-4">
          <a
            href="#custom"
            className="inline-flex items-center gap-2 font-display font-bold text-sm uppercase tracking-wide bg-black text-white rounded-full px-6 py-3 hover:bg-brand-orange transition-colors"
          >
            Start a custom request →
          </a>
          <a
            href="mailto:roger.shirthappensdesigns@gmail.com"
            className="font-body text-sm text-black/70 hover:text-brand-orange transition-colors underline underline-offset-4"
          >
            Or just email me directly.
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
